import React from "react";

import {
  DeleteForever as DeleteForeverIcon,
  MoreHoriz as MoreHorizIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

interface Props {
  onOpen: () => void;
  onDelete: () => void;
}

const useStyles = makeStyles()(() => ({
  icon: {
    marginRight: 8,
    width: 21,
    height: 21,
  },
}));

const OptionMenu: React.FC<Props> = ({ onDelete, onOpen }) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box display="flex" flexDirection="row" marginLeft={1} marginRight={1}>
      <IconButton onClick={handleOpen} size="large">
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            onOpen();
            handleClose();
          }}
        >
          <OpenInNewIcon className={classes.icon} color="primary" />
          <Typography variant="body2" color="primary">
            Open
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDelete();
            handleClose();
          }}
        >
          <DeleteForeverIcon className={classes.icon} htmlColor="#FF6262" />
          <Typography variant="body2" color="error">
            Delete
          </Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default OptionMenu;
